import React, { useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import Footer from '../components/Footer'; // Import the Footer component

const CareerCard = ({ title, description }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  return (
    <Card 
      className={`shadow-sm p-3 mb-4 bg-white rounded border transition-all cursor-pointer ${
        isHovered ? 'shadow-xl border-black scale-105' : 'border-gray-300'
      } ${isClicked ? 'bg-gray-900 text-white' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setIsClicked(!isClicked)}
      style={{ transition: 'transform 0.3s ease, box-shadow 0.3s ease' }}
    >
      <Card.Body>
        <Card.Title className="text-dark fw-bold">{title}</Card.Title>
        <Card.Text className="text-muted">{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

const Careers = () => {
  const careerList = [
    {
      title: "Personal Support Worker (PSW)",
      description: "As a Personal Support Worker, you will provide essential assistance to clients recovering from motor vehicle accidents. Your role involves helping with daily activities, offering emotional support, and ensuring a comfortable and safe environment for rehabilitation."
    },
    {
      title: "Physiotherapist & Massage Therapist",
      description: "Join our team as a physiotherapist or massage therapist and contribute to the recovery of individuals suffering from motor vehicle-related injuries. You will develop treatment plans, provide hands-on therapy, and assist clients in regaining mobility and reducing pain."
    },
    {
      title: "Social Worker",
      description: "As a social worker, you will support clients in managing emotional trauma, stress, and social challenges following an accident. You will provide therapy sessions, help clients access community resources, and advocate for their well-being throughout the recovery process."
    },
    {
      title: "Administrative Assistant",
      description: "We are looking for an organized and detail-oriented administrative assistant to support our healthcare team. Responsibilities include scheduling appointments, managing records, handling client inquiries, and ensuring smooth office operations."
    }
  ];

  return (
    <>
      <Container className="mt-5">
        <Row className="justify-content-center text-center mb-4">
          <Col lg={8}>
            <Image 
              src="/images/careers.png" 
              alt="Careers at Circle of Care & Wellness" 
              fluid 
              className="rounded shadow mb-3"
            />
            <h1 className="fw-bold text-dark">Careers at Circle of Care & Wellness</h1>
            <p className="text-muted">Join our team and make a difference in the lives of those recovering from motor vehicle accidents.</p>
          </Col>
        </Row>
        <Row className="flex-column">
          {careerList.map((career, index) => (
            <Col key={index} className="mb-4">
              <CareerCard {...career} />
            </Col>
          ))}
        </Row>
      </Container>

      {/* Footer Section */}
      <Footer />
    </>
  );
};

export default Careers;
